import { ProfileEditNotesComponent } from './profile-edit-notes/profile-edit-notes.component';
import { SecurityElementNames } from './../../shared/auth/constants/security-element-names.service';
import { AccessControlEntry } from '../../shared/auth/access-control-entry';
import { ProfileEditCustomFieldsComponent } from './profile-edit-custom-fields/profile-edit-custom-fields.component';
import { Component, ViewChild, AfterViewInit, OnDestroy, OnChanges, Input } from '@angular/core';
import { ProfileEditAddressListComponent } from './profile-edit-address/profile-edit-address-list.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ProfileService } from '../shared/profile.service';
import { Subscription } from 'rxjs';
import { ProfileRead } from '../shared/profile-read.model';
import { ProfileMembershipInformationMin } from '../shared/profile-membership-informaiton-min.model';
import { NavigationService } from '../../shared/navigation/navigation.service';
import { DialogResponseEnum } from '.././../shared/dialog/dialog-response-enum';
import { ProfileAddress } from '../shared/profileAddress.model';
import { ProfilePhone } from '../shared/model/profile-phone.model';
import { ProfileEmailAddress } from './../shared/model/profile-email-address.model';
import { ProfileEditEmailsComponent } from './profile-edit-emails/profile-edit-emails.component';
import { ProfileEditPhoneListComponent } from './profile-edit-phone/profile-edit-phone-list.component';
import { ProfileEditSocialMediaComponent } from './profile-edit-social-media/profile-edit-social-media.component';
import { ProfileEditAffiliationsComponent } from './profile-edit-affiliations/profile-edit-affiliations.component';
import { ProfileEditWebPortalCredentialsComponent } from './profile-edit-web-portal-credentials/profile-edit-web-portal-credentials.component';
import { ProfileEditListingListComponent } from './profile-edit-listing/profile-edit-listing-list.component';
import { ProfileEditBillingListComponent } from './profile-edit-billing/profile-edit-billing-list.component';
import { Subject, Observable } from 'rxjs';
import { ProfileEditRelationshipComponent } from './profile-edit-relationship/profile-edit-relationship.component';
import { TabComponent, TabViewComponent } from 'src/app/shared/widgets/tabs';
import { ObservationService } from 'src/app/shared/observation/observation.service';
import { NotificationService, TranslationService } from 'src/app/shared';
import { getSafe } from 'src/app/shared/util/get-safe';
import { ProfileEditProfileTypeComponent } from './profile-edit-profile-type/profile-edit-profile-type.component';
import { VerticalService } from 'src/app/vertical/shared/vertical.service';
import { VerticalTypeEnum } from 'src/app/vertical/shared/vertical-type.enum';
import { NahbProfileTypeEditComponent } from './profile-edit-profile-type/nahb-profile-type-edit/nahb-profile-type-edit.component';
import { MembershipLevelService } from 'src/app/membership-level/shared/membership-level.service';
import { ConfirmationService } from 'primeng/api';
import { MembershipLevelSettingsDto } from 'src/app/membership-level/shared/membership-level-settings.dto';
import { ProfileEditGeneralComponent } from './profile-edit-general/profile-edit-general.component';
import { ProfileEditEmbeddedVideoComponent } from './profile-edit-embedded-video/profile-edit-embedded-video.component';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'wl-profile-edit',
  templateUrl: 'profile-edit.component.html',
  styleUrls: ['profile-edit.component.less'],
  standalone: false,
})
export class ProfileEditComponent implements AfterViewInit, OnDestroy, OnChanges {
  @Input() preventLoad: boolean;
  @Input() hideSaveButtons: boolean;
  @Input() relatedProfileId: number;
  @Input() profileRelationId: number;
  @Input() profileId: number;
  @Input() selectedTab: string;
  @Input() isModal = false;

  @Input()
  get isLoading() {
    return this._isLoading;
  }
  set isLoading(value: boolean) {
    this._isLoading = value;
  }

  @ViewChild(ProfileEditGeneralComponent) _generalComponent: ProfileEditGeneralComponent;
  @ViewChild(ProfileEditAddressListComponent) _addressListComponent: ProfileEditAddressListComponent;
  @ViewChild(ProfileEditEmailsComponent) _emailsComponent: ProfileEditEmailsComponent;
  @ViewChild(ProfileEditPhoneListComponent) _phoneListComponent: ProfileEditPhoneListComponent;
  @ViewChild(ProfileEditSocialMediaComponent) _socialMediaComponent: ProfileEditSocialMediaComponent;
  @ViewChild(ProfileEditAffiliationsComponent) _affiliationsComponent: ProfileEditAffiliationsComponent;
  @ViewChild(ProfileEditWebPortalCredentialsComponent)
  _webPortalCredentialsComponent: ProfileEditWebPortalCredentialsComponent;
  @ViewChild(ProfileEditListingListComponent) _listingsComponent: ProfileEditListingListComponent;
  @ViewChild(ProfileEditBillingListComponent) _billingsComponent: ProfileEditBillingListComponent;
  @ViewChild(ProfileEditRelationshipComponent) _relationshipComponent: ProfileEditRelationshipComponent;
  @ViewChild(ProfileEditCustomFieldsComponent) _customFieldsComponent: ProfileEditCustomFieldsComponent;
  @ViewChild(ProfileEditProfileTypeComponent) _profileTypeComponent: ProfileEditProfileTypeComponent;
  @ViewChild(NahbProfileTypeEditComponent) _nahbEditComponent: NahbProfileTypeEditComponent;
  @ViewChild(ProfileEditNotesComponent) _notesComponent: ProfileEditNotesComponent;
  @ViewChild(ProfileEditEmbeddedVideoComponent) _embeddedVideoComponent: ProfileEditEmbeddedVideoComponent;
  @ViewChild('relationshipTab', { static: false }) _relationshipsTab: TabComponent;
  @ViewChild('tabsContainer', { static: false }) _tabView: TabViewComponent;

  public profile: ProfileRead;
  public memberInformation: ProfileMembershipInformationMin;
  public isSaving: boolean;
  public redirectOnModalClose: boolean;
  public unchangedMemberInformation: string;
  public unchangedProfile: string;
  public unchangedPhones: string;
  public dialogResponse: DialogResponseEnum;
  public dialogResponseEnum: any;
  public addresses: Array<ProfileAddress>;
  public phones: Array<ProfilePhone>;
  public emails: Array<ProfileEmailAddress>;
  public profileSubject = new Subject<number>();
  public relatedProfileSubject = new Subject<number>();
  public showModal = false;
  public showProfileTypeTab = false;
  public showNahb = false;
  private _relatedProfileId: number = 0;
  private _profileSubscription: Subscription;
  private _accessControlEntries: Map<string, AccessControlEntry> = new Map();
  private _membershipLevelSettings: MembershipLevelSettingsDto;
  private _isLoading = false;

  public constructor(
    public securityElementNames: SecurityElementNames,
    private _route: ActivatedRoute,
    private _router: Router,
    private _confirmationService: ConfirmationService,
    private _membershipLevelService: MembershipLevelService,
    private _navigationService: NavigationService,
    private _notificationService: NotificationService,
    private _profileService: ProfileService,
    private _observationService: ObservationService,
    private _translationService: TranslationService,
    private _verticalService: VerticalService,
    private _title: Title
  ) {
    this._profileSubscription = null;
    this.profile = new ProfileRead();
    this.memberInformation = new ProfileMembershipInformationMin();
    this.unchangedMemberInformation = JSON.stringify(this.memberInformation);
    this.dialogResponse = DialogResponseEnum.Yes;
    this.dialogResponseEnum = DialogResponseEnum;
    this.addresses = new Array<ProfileAddress>();
    this.phones = new Array<ProfilePhone>();
    this.emails = new Array<ProfileEmailAddress>();
  }

  getRelatedProfileId() {
    return this._relatedProfileId;
  }

  ngAfterViewInit() {
    if (!this.preventLoad) {
      this._profileSubscription = this._route.params.subscribe((params) => {
        this.profileId = params['id'];
        this.setupComponentData();
      });
    }
    this._membershipLevelService.getMembershipLevelSetting().then((data) => {
      this._membershipLevelSettings = data;
    });
  }

  ngOnChanges() {
    this.setupComponentData();
  }

  public saveClick(redirectOnSave = false) {
    this.isSaving = true;

    getSafe(() => this._webPortalCredentialsComponent.setPortalPasswordOnProfile());

    const allPromises: Array<Promise<number | void>> = [
      ...getSafe(() => this._addressListComponent.save(), []),
      getSafe(() => this._phoneListComponent.save()),
      getSafe(() => this._emailsComponent.save()),
      getSafe(() => this._socialMediaComponent.save()),
      getSafe(() => this._affiliationsComponent.save()),
      getSafe(() => this._listingsComponent.save()),
      getSafe(() => this._billingsComponent.save()),
      getSafe(() => this._relationshipComponent.save()),
      getSafe(() => this._customFieldsComponent.save()),
      getSafe(() => this._notesComponent.save()),
      getSafe(() => this._embeddedVideoComponent.save()),
      this._nahbEditComponent?.save(),
      ...getSafe(() => this._profileTypeComponent.save(), []),
    ];

    const profileDirty: boolean = JSON.stringify(this.profile) != this.unchangedProfile;
    const memberInformationDirty: boolean = JSON.stringify(this.memberInformation) != this.unchangedMemberInformation;

    if (memberInformationDirty) {
      const unchangedMemInfo: ProfileMembershipInformationMin = JSON.parse(this.unchangedMemberInformation);

      if (unchangedMemInfo.MembershipLevelId != this.memberInformation.MembershipLevelId) {
        if (redirectOnSave) {
          this.redirectOnModalClose = true;
          redirectOnSave = false;
        }
        if (!this.isModal) {
          this.showModal = true;
        } else {
          this.handleChangeMembershipLevelModalContinueClick(true);
        }
      }

      if (unchangedMemInfo.MemberSince != this.memberInformation.MemberSince) {
        allPromises.push(this._profileService.setMemberSinceDate(this.profile.ProfileId, this.memberInformation.MemberSince));
      }

      if (unchangedMemInfo.MemberSource !== this.memberInformation.MemberSource) {
        allPromises.push(this._profileService.setMemberSource(this.profile.ProfileId, this.memberInformation.MemberSource));
      }

      if (unchangedMemInfo.MemberNotes !== this.memberInformation.MemberNotes) {
        allPromises.push(this._profileService.setMemberNotes(this.profile.ProfileId, this.memberInformation.MemberNotes));
      }
    }

    return Promise.all(allPromises).then(
      () => {
        if (profileDirty) {
          return this._profileService.updateProfile(this.profile).then(() => {
            this.unchangedProfile = JSON.stringify(this.profile);
            return this.saveCompleted(redirectOnSave).then(() => true);
          });
        } else {
          return this.saveCompleted(redirectOnSave).then(() => true);
        }
      },
      () => {
        this.isSaving = false;
        return false;
      }
    );
  }

  private async saveCompleted(redirectOnSave: boolean) {
    try {
      if (!redirectOnSave) {
        this.refreshProfileData();
      }

      if (this._membershipLevelSettings.MembershipLevelAutoAssignEnabled) {
        const newMembershipLevelId = await this._profileService.getAutoAssignedMembershipLevel(this.profileId);
        if (newMembershipLevelId && newMembershipLevelId.MembershipLevelId != this.profile.MembershipLevelId && !this.isModal) {
          this.changeMembershipLevel(this.profile.MembershipLevelId, newMembershipLevelId.MembershipLevelId, redirectOnSave);
          redirectOnSave = false;
        } else if (newMembershipLevelId && newMembershipLevelId.MembershipLevelId != this.profile.MembershipLevelId) {
          this.forceMLChange(this.profile.MembershipLevelId, newMembershipLevelId.MembershipLevelId);
        }
      }

      if (redirectOnSave) {
        this._router.navigate([`profile/${this.profileId}`]);
      }

      this._observationService.profileUpdated(this.profileId);
    } finally {
      this.isSaving = false;
    }
  }

  public cancelClick() {
    this._navigationService.navigateToProfileView(this.profileId);
  }

  public handleChangeMembershipLevelModalContinueClick(forceChange = false) {
    this.isSaving = true;
    const unchangedMemInfo: ProfileMembershipInformationMin = JSON.parse(this.unchangedMemberInformation);
    let promise = Promise.resolve();
    if (this.dialogResponse === DialogResponseEnum.Yes || forceChange) {
      promise = this._profileService.changeProfileMembershipLevel(
        unchangedMemInfo.ProfileId,
        unchangedMemInfo.MembershipLevelId,
        this.memberInformation.MembershipLevelId
      );
    } else {
      // just change the membership level id
      this.profile.MembershipLevelId = this.memberInformation.MembershipLevelId;
      promise = this._profileService.updateProfile(this.profile);
      this.unchangedProfile = JSON.stringify(this.profile);
    }
    this.unchangedMemberInformation = JSON.stringify(this.memberInformation);
    this.showModal = false;
    promise.then(
      () => {
        this.isSaving = false;
        if (this.redirectOnModalClose) {
          this._router.navigate([`profile/${this.profileId}`]);
        }
      },
      (error) => {
        this.isSaving = false;
        this._notificationService.httpError(error);
      }
    );
  }

  getAccessControlForElement(securityElement: string) {
    if (!this._accessControlEntries.has(securityElement)) {
      this._accessControlEntries.set(securityElement, {
        SecurityElement: securityElement,
        MinimumAccessLevel: 2, // needs full access for all elements on this page
      } as AccessControlEntry);
    }
    return this._accessControlEntries.get(securityElement);
  }

  ngOnDestroy() {
    if (this._profileSubscription) {
      this._profileSubscription.unsubscribe();
    }
  }

  setupComponentData() {
    if (!this.profileId || this.profileId == 0) {
      return;
    }
    this.profileSubject.next(this.profileId);
    // basic profile
    this._profileService.getProfile(this.profileId, true).then((data) => {
      this.profile = data;
      this.unchangedProfile = JSON.stringify(this.profile);
      this.isLoading = false;
      this._title.setTitle(this._translationService.getInstantTitlecase('common.edit') + ' ' + data.ReportName);
    });

    if (this.relatedProfileId) {
      this.relatedProfileSubject.next(this.relatedProfileId);
    }

    // member stuff
    this._profileService.getProfileMembershipInfoMin(this.profileId, true).then((data) => {
      this.memberInformation = data.Member || data.MembershipLevelId != 0 ? data : new ProfileMembershipInformationMin();
      this.profile.Member = this.memberInformation.Member;
      this.profile.MembershipLevelId = this.memberInformation.MembershipLevelId;

      this.unchangedMemberInformation = JSON.stringify(this.memberInformation);
    });

    this._verticalService.GetCurrentUserVerticalType().then((type) => {
      this.showProfileTypeTab = type === VerticalTypeEnum.ApartmentAssociation;
      this.showNahb = type === VerticalTypeEnum.HBA;
    });

    if (this.selectedTab) {
      switch (this.selectedTab.toLowerCase()) {
        case 'relationship':
          this._tabView.select(this._relationshipsTab);
          break;
      }
    }
  }

  refreshProfileData() {
    this._profileService.getProfile(this.profileId, true).then((data) => {
      this.profile = data;
      this.unchangedProfile = JSON.stringify(this.profile);
    });
  }

  private forceMLChange(oldMembershipLevelId: number, newMembershipLevelId: number) {
    this._profileService
      .changeProfileMembershipLevel(this.profileId, oldMembershipLevelId, newMembershipLevelId)
      .then(() => {
        this._notificationService.translateSuccess('common.success');
        this._observationService.profileUpdated(this.profileId);
        this.setupComponentData();
      })
      .catch((error) => {
        this._notificationService.httpError(error);
      });
  }

  private changeMembershipLevel(oldMembershipLevelId: number, newMembershipLevelId: number, redirectOnSave: boolean) {
    this._confirmationService.confirm({
      message: this._translationService.getInstant('profiles.edit.membership-information.auto-assign-confirm-message'),
      key: 'runAutoAssignMembershipLevelCD',
      accept: () => {
        this._profileService
          .changeProfileMembershipLevel(this.profileId, oldMembershipLevelId, newMembershipLevelId)
          .then(() => {
            this._notificationService.translateSuccess('common.success');
            this._observationService.profileUpdated(this.profileId);
            this.setupComponentData();

            if (redirectOnSave) {
              this._router.navigate([`profile/${this.profileId}`]);
            }
          })
          .catch((error) => {
            this._notificationService.httpError(error);
          });
      },
      reject: () => {
        if (redirectOnSave) {
          this._router.navigate([`profile/${this.profileId}`]);
        }
        this._confirmationService.close();
      },
    });
  }

  generalEditChange(profileChange) {
    this.profile = profileChange;
    this._generalComponent.profileChanged(this.profile);
  }

  validateProfile(): boolean {
    let isValid = true;

    if (this._generalComponent?.inheritPhone && this.profile.InheritPhoneFrom == 0) {
      isValid = false;
    }

    if (this._generalComponent?.inheritAddress && this.profile.InheritAddressFrom == 0) {
      isValid = false;
    }

    if (this.profile?.EmployeesFT < 0 || this.profile?.EmployeesPT < 0) {
      isValid = false;
    }

    this._billingsComponent?._billingComponents?.forEach((billing) => {
      if (!billing.value.ItemNum) {
        isValid = false;
      }
    });

    return !isValid;
  }
}
